<header>
    <h1>Contact us</h1>
    <button (click)="close()">
        <svg-icon class="close" src="/assets/icons/cross-thing.svg"></svg-icon>
    </button>
</header>
<p>We hope you enjoy the FlexiCapture Сloud.
   If you have any comments or suggestions on how we can improve  the service,  please do not hesitate to contacts us.
</p>
<!-- <p>
   You can leave a feedback using the special tool included in the service.
   <br />
   Simply click the button <svg-icon class="zopim" src="/assets/icons/zopim.svg"></svg-icon>
   at right bottom corner of the service web pages and tell us what you think about service.
</p> -->
<p class="contacts">
    <svg-icon class="mail" src="/assets/icons/mail.svg"></svg-icon>
    For technical support please write to:
    <a href="mailto:support@flexicapture.com">support@flexicapture.com</a>
    <br />
    <svg-icon class="mail" src="/assets/icons/mail.svg"></svg-icon>
    For administrative queries or feedback:
    <a href="mailto:feedback@flexicapture.com">feedback@flexicapture.com</a>
</p>
<p>We'll do our best to respond within 48 hours.</p>

<p>
    Sincerely,<br />
    FlexiCapture Cloud team.
</p>